import React, { FC, useEffect, useState } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Carousel } from "../Carousel/Carousel";
import { getHexColor, getMediaDevice } from "../../helpers";
import "./index.scss";

interface IEvent {
  backgroundImage: string;
  logoImage: string;
  title: string;
  dates?: string;
  angledBackgroundColor?: string;
  buttonColor?: string;
  buttonTextColor?: string;
  buttonText: string;
  buttonLink: string;
  buttonTarget: string;
  worldTennisBrand?: boolean;
}

interface Props {
  arrowsColor?: string;
  arrowsIconColor?: string;
  featuredTournaments: IEvent[];
}

const EventsList: FC<{
  page: number;
  itemsToDisplay: Record<string, number>;
  list: IEvent[];
  worldTennisBrand: boolean;
}> = ({ page, itemsToDisplay, list, worldTennisBrand }) => {
  return (
    <ReactCSSTransitionGroup
      transitionName="carousel__animation"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
      className={`carousel__animation-container`}
    >
      {list
        .slice(
          page * itemsToDisplay[getMediaDevice()],
          (page + 1) * itemsToDisplay[getMediaDevice()]
        )
        .map((event: IEvent, index: number) => (
          <Event
            {...event}
            worldTennisBrand={worldTennisBrand}
            key={`event-${index}`}
          />
        ))}
    </ReactCSSTransitionGroup>
  );
};

const Event: FC<IEvent> = ({
  backgroundImage,
  logoImage,
  title,
  dates,
  buttonColor,
  buttonTextColor,
  buttonLink,
  buttonTarget = "_self",
  buttonText,
  worldTennisBrand,
  angledBackgroundColor
}) => {
  const schemaColors: Record<string, string> = {
    "--event-buttonColor": buttonColor
      ? getHexColor(buttonColor)
      : "var(--color-yellow)",
    "--event-buttonTextColor": buttonTextColor
      ? getHexColor(buttonTextColor)
      : "var(--color-black)",
    "--angled-backgroundColor": angledBackgroundColor
      ? getHexColor(angledBackgroundColor)
      : "var(--brand--worldTennis__blue--light)"
  };
  return (
    <div className="events__card" style={schemaColors}>
      <div
        className="events__card--preview"
        style={{ backgroundImage: `url("${backgroundImage}")` }}
      />
      {worldTennisBrand ? (
        <div className="events__card-info">
          {title ? <div className="events__card--title">{title}</div> : null}
          {dates ? <div className="events__card--dates">{dates}</div> : null}
          {logoImage ? (
            <div className="events__card--logo">
              <img src={logoImage} alt="" />
            </div>
          ) : null}
          {buttonText ? (
            <a
              href={buttonLink}
              target={buttonTarget}
              className="events__card--btn"
            >
              {buttonText}
            </a>
          ) : null}
        </div>
      ) : (
        <>
          <div className="events__card--logo">
            {logoImage ? <img src={logoImage} alt="" /> : null}
          </div>
          {title ? <div className="events__card--title">{title}</div> : null}
          {dates ? <div className="events__card--dates">{dates}</div> : null}
          {buttonText ? (
            <a
              href={buttonLink}
              target={buttonTarget}
              className="events__card--btn"
            >
              {buttonText}
            </a>
          ) : null}
        </>
      )}
    </div>
  );
};

const Arrow: FC<{ fill: string }> = ({ fill }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0L4.9425 1.0575L9.1275 5.25H0V6.75H9.1275L4.9425 10.9425L6 12L12 6L6 0Z"
      fill={fill}
    />
  </svg>
);

const Events: FC<Props> = ({
  featuredTournaments: list,
  arrowsColor,
  arrowsIconColor = "000"
}) => {
  const itemsToDisplay = { DESKTOPXL: 1, DESKTOP: 1, TABLET: 1, MOBILE: 1 };
  const schemaColors: Record<string, string> = {
    "--event-arrowsColor": arrowsColor
      ? getHexColor(arrowsColor)
      : "var(--color-olympics-blue)"
  };
  let flag = !!document.querySelector(".brand--world-tennis");
  const [worldTennisBrand, isWorldTennisBrand] = useState<boolean>(flag);

  useEffect(() => {
    flag = !!document.querySelector(".brand--world-tennis");
    isWorldTennisBrand(flag);
  }, [worldTennisBrand]);
  console.log({ worldTennisBrand });
  return (
    <div className="events" style={schemaColors}>
      <Carousel
        totalItems={list.length}
        itemsToDisplay={itemsToDisplay}
        pagerPerItem
        chevronNext={
          worldTennisBrand ? (
            <></>
          ) : (
            <Arrow fill={getHexColor(arrowsIconColor)} />
          )
        }
        chevronPrev={
          worldTennisBrand ? (
            <></>
          ) : (
            <Arrow fill={getHexColor(arrowsIconColor)} />
          )
        }
      >
        <EventsList
          worldTennisBrand={worldTennisBrand}
          page={0}
          list={list}
          itemsToDisplay={itemsToDisplay}
        />
      </Carousel>
    </div>
  );
};

export default Events;
